(function () {
  const form      = document.getElementById('facturas-form');
  const alert     = document.getElementById('facturas-alert');
  const submitBtn = document.getElementById('facturas-submit');
  const apiUrl    = form?.dataset.apiUrl;

  if (!form) return;

  // ── File upload UX ──────────────────────────────────────────────────────────

  ['comprobante', 'constancia'].forEach((name) => {
    const input    = document.getElementById(name);
    const zone     = document.getElementById(`${name}-zone`);
    const filename = document.getElementById(`${name}-filename`);

    if (!input || !zone) return;

    input.addEventListener('change', () => updateFileZone(input, zone, filename));

    zone.addEventListener('dragover',  (e) => { e.preventDefault(); zone.classList.add('is-dragover'); });
    zone.addEventListener('dragleave', ()  => zone.classList.remove('is-dragover'));
    zone.addEventListener('drop', (e) => {
      e.preventDefault();
      zone.classList.remove('is-dragover');
      if (e.dataTransfer.files.length) {
        input.files = e.dataTransfer.files;
        updateFileZone(input, zone, filename);
      }
    });
  });

  function updateFileZone(input, zone, filename) {
    const file = input.files[0];
    if (!file) return;
    zone.classList.add('has-file');
    zone.classList.remove('is-invalid');
    if (filename) filename.textContent = file.name;
    clearFieldError(input.name);
  }

  // ── Validation ──────────────────────────────────────────────────────────────

  const MAX_BYTES   = 5 * 1024 * 1024;
  const ALLOWED_EXT = /\.(jpe?g|pdf)$/i;
  const ALLOWED_MIME = ['image/jpeg', 'image/jpg', 'application/pdf'];

  function validateFile(file, label) {
    if (!file)                         return `Selecciona el ${label}.`;
    if (!ALLOWED_EXT.test(file.name))  return `${label}: solo se permiten archivos JPG o PDF.`;
    if (!ALLOWED_MIME.includes(file.type)) return `${label}: tipo de archivo no permitido.`;
    if (file.size > MAX_BYTES)         return `${label}: el archivo supera 5 MB.`;
    return null;
  }

  function showFieldError(name, msg) {
    const el = document.getElementById(`error-${name}`);
    const input = form.querySelector(`[name="${name}"]`);
    if (el)    { el.textContent = msg; el.classList.add('is-visible'); }
    if (input) input.classList.add('is-invalid');
  }

  function clearFieldError(name) {
    const el = document.getElementById(`error-${name}`);
    const input = form.querySelector(`[name="${name}"]`);
    if (el)    { el.textContent = ''; el.classList.remove('is-visible'); }
    if (input) input.classList.remove('is-invalid');
  }

  function clearAllErrors() {
    form.querySelectorAll('.facturas-form__field-error').forEach((el) => {
      el.textContent = ''; el.classList.remove('is-visible');
    });
    form.querySelectorAll('.is-invalid').forEach((el) => el.classList.remove('is-invalid'));
    hideAlert();
  }

  // ── Alert helpers ───────────────────────────────────────────────────────────

  function showAlert(msg, type) {
    alert.textContent = msg;
    alert.className   = `facturas-form__alert is-${type}`;
    alert.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideAlert() {
    alert.className = 'facturas-form__alert';
  }

  // ── Submit ──────────────────────────────────────────────────────────────────

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearAllErrors();

    const data = new FormData(form);
    let hasErrors = false;

    // Required text fields
    [['customerName', 'Nombre'], ['orderNumber', 'Número de orden'], ['email', 'Correo electrónico'], ['usoCfdi', 'Uso de CFDI'], ['formaPago', 'Forma de pago']].forEach(([name, label]) => {
      if (!data.get(name)?.toString().trim()) {
        showFieldError(name, `${label} es requerido.`);
        hasErrors = true;
      }
    });

    // Email format
    const email = data.get('email')?.toString().trim();
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showFieldError('email', 'Formato de correo no válido.');
      hasErrors = true;
    }

    // Files
    const comprobanteFile = document.getElementById('comprobante').files[0];
    const constanciaFile  = document.getElementById('constancia').files[0];

    const comprobanteErr = validateFile(comprobanteFile, 'Comprobante de pago');
    const constanciaErr  = validateFile(constanciaFile,  'Constancia de situación fiscal');

    if (comprobanteErr) { showFieldError('comprobante', comprobanteErr); hasErrors = true; }
    if (constanciaErr)  { showFieldError('constancia',  constanciaErr);  hasErrors = true; }

    if (hasErrors) return;

    if (!apiUrl) {
      showAlert('El formulario no está configurado correctamente. Contacta al administrador.', 'error');
      return;
    }

    // Loading state
    submitBtn.disabled = true;
    submitBtn.classList.add('is-loading');

    try {
      const res  = await fetch(apiUrl, { method: 'POST', body: data });
      const json = await res.json();

      if (res.ok && json.ok) {
        form.reset();
        document.querySelectorAll('.facturas-form__upload').forEach((z) => {
          z.classList.remove('has-file');
        });
        document.querySelectorAll('.facturas-form__upload-filename').forEach((el) => {
          el.textContent = '';
        });
        showAlert('¡Solicitud enviada! Te contactaremos en un plazo de 2 días hábiles.', 'success');
      } else {
        showAlert(json.error || 'Ocurrió un error. Intenta de nuevo.', 'error');
      }
    } catch {
      showAlert('No se pudo conectar con el servidor. Verifica tu conexión e intenta de nuevo.', 'error');
    } finally {
      submitBtn.disabled = false;
      submitBtn.classList.remove('is-loading');
    }
  });
})();
